<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid>
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardBody>
                                <CTabs variant="tabs" :active-tab="0">
                                    <!-- General -->
                                    <CTab :title="$t('general')">
                                        <CCard bodyWrapper>
                                            <h6>
                                                {{
                                                    $t("new_client_description")
                                                }}
                                            </h6>
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'client_data',
                                                        fieldName: 'name',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.client_data.name
                                                        .$model
                                                "
                                                :label="$t('name')"
                                                :placeholder="
                                                    $t('enter_the_name')
                                                "
                                                :invalidFeedback="
                                                    $t('name_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CSelect
                                                :value.sync="
                                                    $v.forms.client_data.type
                                                        .$model
                                                "
                                                :options="[
                                                    {
                                                        label: $t('client'),
                                                        value: 'client',
                                                    },
                                                    {
                                                        label: $t('sponsor'),
                                                        value: 'sponsor',
                                                    },
                                                    {
                                                        label: $t('coregister'),
                                                        value: 'coregister',
                                                    },
                                                ]"
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :horizontal="default_horizontal"
                                                :label="$t('type')"
                                                size="sm"
                                            />
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'client_data',
                                                        fieldName: 'cif',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.client_data.cif
                                                        .$model
                                                "
                                                :label="$t('cif')"
                                                :placeholder="
                                                    $t('enter_the_cif')
                                                "
                                                :invalidFeedback="
                                                    $t('cif_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CTextarea
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'client_data',
                                                        fieldName:
                                                            'description',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.client_data
                                                        .description.$model
                                                "
                                                :label="$t('description')"
                                                :placeholder="
                                                    $t('enter_the_description')
                                                "
                                                :invalidFeedback="
                                                    $t(
                                                        'description_is_required'
                                                    )
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'client_data',
                                                        fieldName: 'address',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.client_data.address
                                                        .$model
                                                "
                                                :label="$t('address')"
                                                :placeholder="
                                                    $t('enter_the_address')
                                                "
                                                :invalidFeedback="
                                                    $t('address_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'client_data',
                                                        fieldName: 'province',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.client_data
                                                        .province.$model
                                                "
                                                :label="$t('province')"
                                                :placeholder="
                                                    $t('enter_the_province')
                                                "
                                                :invalidFeedback="
                                                    $t('province_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'client_data',
                                                        fieldName: 'cp',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.client_data.cp
                                                        .$model
                                                "
                                                :label="$t('postal_code')"
                                                :placeholder="
                                                    $t('enter_the_postal_code')
                                                "
                                                :invalidFeedback="
                                                    $t(
                                                        'postal_code_is_required'
                                                    )
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <SelectCountry
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'client_data',
                                                        fieldName: 'country_id',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.client_data
                                                        .country_id.$model
                                                "
                                                :label="$t('country')"
                                                :placeholder="
                                                    $t('select_a_country')
                                                "
                                                :invalidFeedback="
                                                    $t('country_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <SelectLanguage
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'client_data',
                                                        fieldName:
                                                            'language_id',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.client_data
                                                        .language_id.$model
                                                "
                                                :label="$t('language')"
                                                :placeholder="
                                                    $t('select_a_language')
                                                "
                                                :invalidFeedback="
                                                    $t('language_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />

                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'client_data',
                                                        fieldName:
                                                            'link_conditions',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.client_data
                                                        .link_conditions.$model
                                                "
                                                :label="$t('link_conditions')"
                                                :placeholder="
                                                    $t('link_conditions')
                                                "
                                                :invalidFeedback="
                                                    $t('url_invalid')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />

                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'client_data',
                                                        fieldName: 'logo',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.client_data.logo
                                                        .$model
                                                "
                                                :label="$t('logo')"
                                                :placeholder="$t('url_logo')"
                                                :invalidFeedback="
                                                    $t('url_invalid')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                        </CCard>
                                    </CTab>
                                </CTabs>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <!-- Button send -->
                                <ButtonSave
                                    @click="submitForm($event, 'client_data')"
                                    :disabled="forms.client_data._loading"
                                />
                                <!-- Button back -->

                                <ButtonBack />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import SelectCountry from "£lement/SelectCountry";
import SelectLanguage from "£lement/SelectLanguage";
import ButtonBack from "£lement/ButtonBack";
import ButtonSave from "~/components/ButtonSave.vue";

/**
 * Mixins
 */
import pageMixin from "~/mixins/page";
import formMixin from "~/mixins/form";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilPlus,
    cilTrash,
} from "@coreui/icons";
import { validationMixin } from "vuelidate";
import { required, url } from "vuelidate/lib/validators";

export default {
    name: "ClientViewPage",
    middleware: ["auth", "page"],
    mixins: [validationMixin, pageMixin, formMixin],
    components: {
        SelectCountry,
        SelectLanguage,
        ButtonBack,
        ButtonSave,
    },
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilPlus,
        cilTrash,
    },
    data: function () {
        return {
            forms: {
                client_data: {
                    name: null,
                    cif: null,
                    description: null,
                    address: null,
                    province: null,
                    cp: null,
                    country_id: null,
                    language_id: null,
                    link_conditions: null,
                    logo: null,
                    client_segment: null,
                    type: null,
                    _loading: false,
                },
            },
        };
    },
    computed: {
        uuid: function () {
            return this.$route.params.uuid;
        },
    },

    validations: {
        forms: {
            client_data: {
                name: {
                    required,
                },
                type: {
                    required,
                },
                cif: {},
                description: {},
                address: {},
                province: {},
                cp: {},
                country_id: {
                    required,
                },
                language_id: {
                    required,
                },
                link_conditions: {
                    url,
                },
                logo: {
                    url,
                },
            },
        },
    },
    methods: {
        async submitForm(e, formName) {
            if (e) e.preventDefault();
            if (this.uuid) {
                await this.sendForm({
                    formName,
                    url: "/clients.api/" + this.uuid + "/update",
                    method: "PUT",
                });
            } else {
                await this.sendForm({
                    formName,
                    url: "/clients.api/create",
                });
            }
            this.$router.go(-1);
        },
    },
    async mounted() {
        if (this.uuid) {
            await this.updateForm({
                formName: "client_data",
                url: "/clients.api/" + this.uuid,
            });
        }
        this.updatePageLoading(false);
    },
};
</script>

<style scoped lang="scss">
</style>